module.exports = __webpack_public_path__ + "static/img/banner.cddc33e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.png
// module id = 59
// module chunks = 0